module.exports = __webpack_public_path__ + "img/prioritas_bosspack_cod.cd9320a2.png";